import { Divider } from "@mui/material";
import { SideNav, SideNavContent } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import { DisplayBox } from "components/OutputBox";
import UploadFile from "components/UploadFile";
import {
  BaseDropdown,
  BaseInput,
  HeaderDasNew,
  LargeButton,
  MainBody,
  Ptag,
} from "components/core";
import { Form, Formik } from "formik";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { calculateGrossPremium } from "../UploadPolicyId";
import {
  formatDate,
  formatToRupees,
  newFormatRupees,
  products,
  rupeesToNumber,
  userplanIdFlex,
} from "utlis/utils";
import { colors, theme } from "theme";
import http from "services/httpService";
import routes from "components/routes";
import PageHeader from "components/UniversalComponents/PageHeader";
import BaseDateInput from "components/UniversalComponents/BaseDateInput";

function PostIssuanceUhidUpload() {
  const payment_value_exist = localStorage.getItem('uhid_upload_values') && JSON.parse(localStorage.getItem('uhid_upload_values'))
  const company_name = localStorage.getItem("company_name");
  const product_detail = JSON.parse(localStorage.getItem("gmc_details"));
  const options = products();
  const [uploadType, setUploadType] = useState("Upload Endorsment Copy");
  const navigation = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [excelId, setExcelId] = useState("");
  const [pdfId, setPdfId] = useState("");
  const [empSheet, setEmpSheet] = useState("");
  const [grossPremium, setGrossPremium] = useState('₹0');
  const [excelFileName, setExcelFileName] = useState("");
  const [pdfName, setPdfName] = useState("");
  const [empSheetName, setEmpSheetName] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const updateSelectedValue = (value) => {
    setSelectedValue(value);
    value &&
      !product_detail[value].is_payment_done &&
      setUploadType("Upload Inception Copy");
  };
  const getOptions = (options) => {
    return options.map((option) => ({
      ...option,
      title: option.label,
    }));
  };
  const handleSubmit = async (values) => {
    if (!excelId || !pdfId) {
      alert("Pleaes enter UHID and Invoice.");
      return;
    }
    try {
      const userplan_id = userplanIdFlex(selectedValue);
      const postData = {
        uhid_file_id: excelId,
        userplan_id: userplan_id,
        invoice_id: pdfId,
        payment_date: formatDate(values.date),
        amount: rupeesToNumber(grossPremium),
        net_premium: rupeesToNumber(values.premium),
        cgst: rupeesToNumber(values.cgst),
        sgst: rupeesToNumber(values.sgst),
        igst: rupeesToNumber(values.igst),
        employee_wise_breakup_sheet_id: empSheet,
        endorsement_number: values.endorsNumber,
      };
      const { data } = await http.post(
        "/business/upload_employee_issuance_data/",
        [postData]
      );
      localStorage.setItem("super_task_id", data);
      localStorage.setItem('uhid_upload_values', JSON.stringify(values))
      navigation(`/${routes.POST_ISSUANCE_PENDING_STATUS}`);
    } catch (e) {
      console.log(e);
    }
  };

  const calculateGrossPremium = (value) => {
    const cgst = rupeesToNumber(value?.cgst),
      igst = rupeesToNumber(value?.igst),
      sgst = rupeesToNumber(value?.sgst),
      premium = rupeesToNumber(value?.premium);
    const gross = (cgst + igst + sgst + premium).toString();
    setGrossPremium(newFormatRupees(gross));
  };
  const validationSchema = Yup.object().shape({
    policy_type: Yup.string().required("*Required"),
    date: Yup.string().required("Date is required"),
    endorsNumber: Yup.string().test(
      "conditionalEndorsNumber",
      "Endorsment Number is required",
      function (value) {
        if (uploadType === "Upload Endorsment Copy" && !value) {
          return false; // Validation fails if endorsNumber is required but not provided
        }
        return true; // Validation passes otherwise
      }
    ),
    premium: Yup.string().required("Premium is required"),
    cgst: Yup.string().required("CGST is required"),
    sgst: Yup.string().required("SGST is required"),
    igst: Yup.string().required("IGST is required"),
  });
  const downloadFile = () => {
    const INCEPTION_TEMPLATE = "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/inception_uhid_template.xlsx";
    const ENDORSEMENT_TEMPLATE = "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/Endorsement_sheet_add_delete_final+1.xlsx";
    if (uploadType == "Upload Inception Copy") {
      window.open(INCEPTION_TEMPLATE)
    } else {
      window.open(ENDORSEMENT_TEMPLATE)
    }
  }
  let InitialValues = {
    date: "",
    endorsNumber: "",
    premium: "",
    cgst: "",
    sgst: "",
    igst: "",
    gross_premium: "",
    policy_type: "",
  };
  if(payment_value_exist){
    InitialValues = payment_value_exist
  }
  
  return (
    <>
      <SideNav>
        <SideNavContent />
      </SideNav>
      <HeaderDasNew company_name={company_name} />
      <MainBody>
        <WidthLimiter>
          <Formik
            validationSchema={validationSchema}
            initialValues={InitialValues}
            validateOnChange={true}
            validateOnBlur={false}
            onSubmit={handleSubmit}
          >
            {(formikProps) => (
              <div style={{ marginBottom: "2.8rem" }}>
                {calculateGrossPremium(formikProps?.values)}
                <Form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                  }}
                >
                  {/* <Ptag
                    fontSize="20px"
                    fontWeight="700"
                    letterHeight="1.33"
                    letterSpacing="0.35px"
                    style={{ paddingBottom: "10px" }}
                  >
                    Upload Enrolments
                  </Ptag> */}
                  <PageHeader header={"Upload Enrolments"} />
                  <div style={{ marginBottom: "2.2rem", width: "50%" }}>
                    {updateSelectedValue(formikProps.values?.policy_type)}
                    <BaseDropdown
                      fontSize="14"
                      fontColor={colors.defaultFontColor}
                      label="Select Policy Type"
                      options={getOptions(options)}
                      formikProps={{ ...formikProps, name: "policy_type" }}
                    />
                  </div>
                  <UploadFile
                    headerMargin="12px 0"
                    label="Client IDs"
                    text="Upload File"
                    sampleFile="UHID_sheet"
                    onDownload={() => downloadFile()}
                    format="excel"
                    type="policy_upload_excel"
                    onSelect={setExcelId}
                    fileName={setExcelFileName}
                  />
                  <Divider
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  />
                  <Ptag
                    fontSize="24px"
                    fontWeight="700"
                    marginTop="30px"
                    marginBottom="20px"
                  >
                    Upload Payment Details
                  </Ptag>

                  <div
                    style={{
                      display: "flex",
                      gap: "2rem",
                      maxWidth:
                        uploadType == "Upload Inception Copy"
                          ? "400px"
                          : "800px",
                    }}
                    className="date-numeber-wrapper"
                  >
                    {/* <BaseInput
                      staticLabel="Date"
                      date
                      fontSize="16px !important"
                      formikProps={{
                        ...formikProps,
                        name: "date",
                      }}
                    /> */}
                    <BaseDateInput
                      staticLabel="Issuance Date"
                      onlyPastDate={true}
                      formikProps={{ ...formikProps, name: "date" }}
                    />
                    {uploadType !== "Upload Inception Copy" && (
                      <BaseInput
                        staticLabel="Endorsement Number"
                        // pincode
                        fontSize="16px !important"
                        formikProps={{
                          ...formikProps,
                          name: "endorsNumber",
                        }}
                      />
                    )}
                  </div>
                  <div style={{ maxWidth: "400px" }}>
                    <BaseInput
                      staticLabel="Premium"
                      type="number"
                      // formatToRupee
                      fontSize="16px !important"
                      formikProps={{
                        ...formikProps,
                        name: "premium",
                      }}
                    />
                  </div>
                  <Ptag fontSize="14px" marginBottom="-5px">
                    Taxes
                  </Ptag>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <BaseInput
                        staticLabel="CGST"
                        type="number"
                        fontSize="16px !important"
                        formikProps={{
                          ...formikProps,
                          name: "cgst",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <BaseInput
                        staticLabel="SGST"
                        type="number"
                        fontSize="16px !important"
                        formikProps={{
                          ...formikProps,
                          name: "sgst",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <BaseInput
                        staticLabel="IGST"
                        type="number"
                        fontSize="16px !important"
                        formikProps={{
                          ...formikProps,
                          name: "igst",
                        }}
                      />
                    </div>
                  </div>
                  <DisplayBox value={grossPremium} label="Gross Premium" />
                  <UploadFile
                    headerMargin="12px 0"
                    label={uploadType}
                    text={"Upload File"}
                    format="pdf"
                    type="premiums_invoice"
                    onSelect={setPdfId}
                    fileName={setPdfName}
                  />
                  <Divider
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  />
                  <UploadFile
                    headerMargin="12px 0"
                    label={"Employee-wise Breakup Sheet (optional)"}
                    text={"Upload File"}
                    format="excel"
                    type="employee_wise_breakup"
                    onSelect={setEmpSheet}
                    fileName={setEmpSheetName}
                  />
                  <LargeButton id="" label={"Update"} type="submit" />
                </Form>
              </div>
            )}
          </Formik>
        </WidthLimiter>
      </MainBody>
    </>
  );
}

export default PostIssuanceUhidUpload;

